

import axios from "../api/axios";
import useAuth from "./useAuth";

let isLoggingOut = false;

const useLogout = () => {


    
    const { setAuth } = useAuth();
    
const logout = async () => {
  localStorage.removeItem("persist");
  isLoggingOut = true;

  try {
    await axios.post("/logout", {}, { withCredentials: true });
  } catch (err) {
    console.error(err);
  } finally {
     isLoggingOut = false;  
    setAuth({});
  }
};


    return logout;
};

export const getIsLoggingOut = () => isLoggingOut;

export default useLogout;
